import React, { ReactNode } from 'react'
import Heading from 'components/generic/Heading'
import useWindowSize from 'hooks/use-windowSize'
import { WTNScale } from '@clubspark-react/clubspark-itf-shared-components'
import { DESKTOP_BREAKPOINT } from 'constants/global'
import styles from './psq.module.scss'
import { useTranslation } from 'react-i18next'
import { PsqResults } from 'types/global'
import BtnPrimary from 'components/generic/BtnPrimary'

interface Props {
  results: PsqResults
  text: ReactNode
  cta: {
    text: string
    href: string
  }
}

const PsqConfirmation = ({ results, text, cta }: Props) => {
  const windowWidth = useWindowSize().width
  const isMobile = windowWidth && windowWidth < DESKTOP_BREAKPOINT

  return (
    <div className={styles.psqConfirmation}>
      {isMobile && <Title />}
      <Widget results={results} />
      <div className={styles.psqConfirmationTextWrapper}>
        {!isMobile && <Title />}

        {text}

        <BtnPrimary className={styles.cta} href={cta.href} size='medium' fullWidthAtMobile>
          {cta.text}
        </BtnPrimary>
      </div>
    </div>
  )
}

interface WidgetProps {
  results: PsqResults
}

const Widget = ({ results }: WidgetProps) => {
  return (
    <div className={styles.widgetWrapper}>
      <WTNScale
        mode={''}
        border={true}
        animDuration={4500}
        labelsDesktop
        mobileBreakPoint={767.98}
        width={360}
        wtnSingles={results.wtnSingles}
        wtnDoubles={results.wtnDoubles}
        sourceIsPsqSingles
        sourceIsPsqDoubles
        infoIcon={false}
        infoModal={false}
      />
    </div>
  )
}

const Title = () => {
  const { t } = useTranslation()

  return <Heading>{t('screenCompleted.common.heading', { ns: 'strPsq' })}</Heading>
}

export default PsqConfirmation
